import {
  GET_MANUAL_ORDER_ERROR,
  GET_MANUAL_ORDER_REQUEST,
  GET_MANUAL_ORDER_RESET,
  GET_MANUAL_ORDER_SUCCESS,
} from "redux/actions/action-type";

const initialState = {
  orders: [],
  errorDetails: {},
  metadata: {},
  isviewManualOrdersErrorLoading: false,
  isviewManualOrdersError: false,
  isviewManualOrdersSuccess: false,
};

const viewManualordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUAL_ORDER_REQUEST:
      return {
        ...state,
        isviewManualOrdersErrorLoading: true,
        isviewManualOrdersError: false,
        isviewManualOrdersSuccess: false,
      };

        case GET_MANUAL_ORDER_SUCCESS:
            const { orders: newOrders, metadata: newMetadata } = action.payload;
            const { orders: existingOrders } = state;
            let mergedOrders;
            if (existingOrders) {
                mergedOrders = [...existingOrders, ...newOrders];
            } else {
                mergedOrders = newOrders;
            }
            return {
                ...initialState,
                isviewManualOrdersErrorLoading: false,
                orders: mergedOrders,
                metadata: newMetadata,
                isviewManualOrdersError: false,
                isviewManualOrdersSuccess: true,
                errorDetails: {},
            };

    case GET_MANUAL_ORDER_ERROR:
      return {
        ...state,
        isviewManualOrdersErrorLoading: false,
        orders: [],
        isviewManualOrdersError: true,
        isviewManualOrdersSuccess: false,
        errorDetails: action.payload,
      };

    case GET_MANUAL_ORDER_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default viewManualordersReducer;
